// Per-browser persistence layer for HumaClub dynamic interactions.
// Replaces former backend endpoints: comments, reactions, follows, bookmarks, user_posts.

const PREFIX = 'humaclub:';

function safeKey(key) {
  return `${PREFIX}${key}`;
}

export function getStore(key) {
  try {
    const raw = localStorage.getItem(safeKey(key));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function setStore(key, value) {
  try {
    localStorage.setItem(safeKey(key), JSON.stringify(value));
  } catch {
    // Quota exceeded or storage unavailable — ignore.
  }
}

export function addItem(key, item) {
  const list = getStore(key);
  const enriched = {
    id: item.id || `${key}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    createdAt: item.createdAt || new Date().toISOString(),
    ...item,
  };
  list.push(enriched);
  setStore(key, list);
  return enriched;
}

export function removeItem(key, id) {
  const list = getStore(key).filter(x => x.id !== id);
  setStore(key, list);
  return list;
}

export function findItems(key, predicate) {
  return getStore(key).filter(predicate);
}
